module.exports = __webpack_public_path__ + "static/media/slider-l6-768.3522863c.webp";